module.exports = __webpack_public_path__ + "static/media/admin_img_novo_usuario.83bf1154.svg";